import React, { useEffect, useRef, useState } from 'react';
import { useI18n } from '../../i18n';

const STAT_VALUES = [1000, 1800, 800, 30];

const useInView = () => {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const el = ref.current; if (!el) return;
    const obs = new IntersectionObserver((entries) => entries.forEach((e) => e.isIntersecting && setInView(true)), { threshold: 0.3 });
    obs.observe(el);
    return () => obs.disconnect();
  }, []);
  return [ref, inView];
};

const Counter = ({ end, suffix = '+' }) => {
  const [n, setN] = useState(0);
  const [ref, inView] = useInView();
  useEffect(() => {
    if (!inView) return;
    const duration = 1400; const start = performance.now();
    let raf;
    const tick = (ts) => {
      const p = Math.min(1, (ts - start) / duration);
      setN(Math.floor(end * (0.2 + 0.8 * p * p * (3 - 2 * p))));
      if (p < 1) raf = requestAnimationFrame(tick); else setN(end);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [inView, end]);
  return <span ref={ref}>{n}{suffix}</span>;
};

const About = () => {
  const { t } = useI18n();
  const features = t('about.features') || [];
  const stats = t('about.stats') || [];

  return (
    <section id="about" className="py-20 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-6">
          <span className="text-xs font-semibold uppercase tracking-widest text-orange-600">{t('about.kicker')}</span>
          <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-extrabold text-slate-900">
            {t('about.titleA')} <span className="text-orange-500">{t('about.titleB')}</span>
          </h2>
          <p className="mt-5 text-slate-600">{t('about.body')}</p>

          <div className="mt-8 grid sm:grid-cols-2 gap-4">
            {features.map((f) => (
              <div key={f.t} className="rounded-xl border border-slate-200 p-4 hover:border-orange-300 transition-colors">
                <div className="font-semibold text-slate-900">{f.t}</div>
                <div className="text-sm text-slate-600 mt-1">{f.d}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="lg:col-span-6">
          <div className="grid grid-cols-2 gap-4">
            {stats.map((s, i) => (
              <div key={s.label} className="rounded-2xl border border-slate-200 p-6 bg-gradient-to-br from-slate-50 to-white hover:shadow-lg transition-shadow">
                <div className="text-4xl sm:text-5xl font-extrabold text-slate-900"><Counter end={STAT_VALUES[i]} suffix="+" /></div>
                <div className="mt-2 text-sm text-slate-600">{s.label}</div>
              </div>
            ))}
          </div>

          <div className="mt-6 rounded-2xl border border-slate-200 p-6 bg-slate-900 text-white">
            <div className="text-sm text-orange-300">{t('about.gapKicker')}</div>
            <div className="mt-2 text-2xl font-bold">{t('about.gapTitle')}</div>
            <p className="mt-2 text-slate-300 text-sm">{t('about.gapBody')}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
